import 'antd/dist/antd.variable.min.css';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './index.scss';
import './lib/utils/i18n';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container as Element);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
